	export enum DaysOfTheWeek {
		Sunday = 1,
		Monday = 2,
		Tuesday = 4,
		Wednesday = 8,
		Thursday = 16,
		Friday = 32,
		Saturday = 64,
		AllDays = 127
	}
	export enum MonthsOfTheYear {
		January = 1,
		February = 2,
		March = 4,
		April = 8,
		May = 16,
		June = 32,
		July = 64,
		August = 128,
		September = 256,
		October = 512,
		November = 1024,
		December = 2048,
		AllMonths = 4095
	}
	export enum TaskState {
		Unknown = 0,
		Disabled = 1,
		Queued = 2,
		Ready = 3,
		Running = 4
	}
	export enum TaskTriggerType {
		Event = 0,
		Time = 1,
		Daily = 2,
		Weekly = 3,
		Monthly = 4,
		MonthlyDOW = 5,
		Idle = 6,
		Registration = 7,
		Boot = 8,
		Logon = 9,
		SessionStateChange = 11,
		Custom = 12
	}
	export enum WhichWeek {
		FirstWeek = 1,
		SecondWeek = 2,
		ThirdWeek = 4,
		FourthWeek = 8,
		LastWeek = 16,
		AllWeeks = 31
	}



// WEBPACK FOOTER //
// ./typings/board/TaskScheduler.ts